export enum CustomerTypes {
  EXHIBITING_DELEGATE = "exhibitingDelegate",
  CONTRACTOR = "contractor",
  STAFF = "staff",
  VIP = "vipOrBuyersProg"
}


export enum CustomerTypeFilter {
  CONFERENCE_DELEGATE = "conferenceDelegate",
  CONTRACTOR = "contractor",
  EXHIBITING_DELEGATE = "exhibitingDelegate",
  HOSTED_BUYER = "hostedBuyer",
  PRESS_OR_MEDIA = "pressOrMedia",
  PUBLIC = "public",
  SPEAKER = "speaker",
  STAFF = "staff",
  STUDENT_OR_LECTURER = "studentOrLecturer",
  TRADE_VISITOR = "tradeVisitor",
  VIP_OR_BUYERS_PROG = "vipOrBuyersProg"
}

export const customerTypeFilterKeys =  Object.values(CustomerTypeFilter) as CustomerTypeFilter[];